export const dominikaChylinska = {
    'meta': {
        'title': 'Psychiatra Dominika Chylińska-Mazurkiewicz • Centrum COLLIGO',
        'description': 'Lekarz psychiatra z ponad 15 letnim stażem. Doświadczenie zawodowe zdobywałam w Szpitalu Zespolonym w Toruniu oraz Poradniach Zdrowia Psychicznego.'
    },
    'url': {
        'address': '/torun/zespol/dominika-chylinska-psychiatra/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/dominika-chylinska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra Dominika Chylińska-Mazurkiewicz'
        }
    }
}